"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTab = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const framer_motion_1 = require("framer-motion");
const react_1 = require("react");
const components_1 = require("./components");
const FormContext_1 = require("../FormContext");
const StatusBadge = (0, app_1.styled)(components_1.Badge) `
  overflow: hidden;
`;
const BadgeContent = (0, app_1.styled)(framer_motion_1.motion.div) `
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
function FormTab({ page, title, description, }) {
    const { setActivePage, activePage, successPage } = (0, FormContext_1.useFormContext)();
    const active = page === activePage;
    const completed = page < activePage;
    const switchPage = (0, react_1.useCallback)(() => (successPage ? null : setActivePage(page)), [page, setActivePage, successPage]);
    return ((0, jsx_runtime_1.jsxs)(components_1.Wrap, { children: [(0, jsx_runtime_1.jsx)(components_1.Description, { children: description }), (0, jsx_runtime_1.jsxs)(components_1.TabContent, Object.assign({ onClick: switchPage, "$active": active }, { children: [title, (0, jsx_runtime_1.jsx)(StatusBadge, Object.assign({ "$active": active }, { children: (0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: (0, jsx_runtime_1.jsx)(BadgeContent, Object.assign({ initial: { y: 10, opacity: 0 }, animate: { y: 0, opacity: 1 }, exit: { y: -10, opacity: 0 }, transition: { duration: 0.2 } }, { children: completed ? (0, jsx_runtime_1.jsx)(svg_1.SvgCheck, { height: "1rem" }) : page }), String(completed)) }) }))] }))] }));
}
exports.FormTab = FormTab;
